import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProductFilterBody = _resolveComponent("ProductFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    ref: "productFilterItem",
    class: "product-filter",
    id: "products",
    icon: "ProductsIcon",
    title: $options.getProductsTitle,
    selectedTitle: $options.getProductsSelectedTitle,
    selectedCount: $props.products?.filterState?.selectedCount,
    onClearAll: $options.onClear,
    onApply: $options.onApply,
    onHidden: $options.onHidden
  }, {
    body: _withCtx(() => [_createVNode(_component_ProductFilterBody, {
      title: "Products",
      selected: $props.products?.filterState?.selected,
      isModified: $props.products.isModified,
      pendingChanges: $props.products.pendingChanges,
      isSearching: $props.products.isSearching,
      keyword: $props.products.keyword,
      list: $props.products.displayList,
      onClear: $options.onClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.onSelect,
      onSelectOnly: $options.onSelectOnly,
      onSelectAll: $options.onSelectAll,
      onDeselect: $options.onDeSelect,
      onApply: $options.onApply,
      onSearch: $options.handleProductsSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: $options.onClose
    }, null, 8, ["selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onSelectAll", "onDeselect", "onApply", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 1
  }, 8, ["title", "selectedTitle", "selectedCount", "onClearAll", "onApply", "onHidden"]);
}